import { Component, Input, OnInit } from '@angular/core';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';

@Component({
  selector: 'result-save-alert-dialog',
  templateUrl: './result-save-alert-dialog.component.html',
  styleUrls: ['./result-save-alert-dialog.component.scss'],
})
export class ResultSaveAlertDialogComponent implements OnInit {

  constructor(
    private logService: LogService,
    private modalService: ModalService,
  ) { }

  @Input() description: string = "내 프로필에서 전체 결과와 친구들의 응답을 확인할 수 있어요"

  ngOnInit() {
  }

  resultSaveModalImPressionLogging():void{
    this.logService.resultSaveModalImpressionLogging();
  }

  resultSaveModalButtonClickLogging():void{
    this.logService.resultSaveModalButtonClickedLogging();
  }

  onClickButton(): void {
    this.modalService.dismiss(true);
  }
}
